"use strict";

var EmailView = require('./EmailView');
var SendToFriendView = module.exports = EmailView.extend();
var _ = require('underscore');

require('bunsen/libraries/plugins/dibs-validation');

_.extend(SendToFriendView.prototype, {

    initialize : function (options) {
        this.options = options || {};
        EmailView.prototype.initialize.apply(this, arguments);
        this.subs.add('inputField', {
            el: '#to_email'
        });
        this.subs.findWhere({name: 'message'}).validation.required = false;
    },
    initValidation : function () {
        EmailView.prototype.initValidation.apply(this);
        this.$el.dibsValidation('addCustomValidator', 'to_email', this.isRecipientFieldValid, this);
    },
    /**
     * custom dibsvalidation function for emaillist
     * @returns {String} if false {Boolean} if true
     */
    isRecipientFieldValid : function () {
        return this.validateEmailList(this.subs.findWhere({name: 'to_email'}).getValue());
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/modalEmail/views/SendToFriendView.js
// module id = 1192
// module chunks = 4 7 12